<script setup lang="ts">
const emit = defineEmits<{
  (e: 'retry'): void
}>()
const { isLoading } = defineProps<{
  isLoading: boolean
}>()
</script>

<template>
  <div class="flex justify-center items-center h-screen">
    <div class="flex items-center flex-col gap-2">
      <template v-if="isLoading">
        <Icon icon="svg-spinners:blocks-wave" class="text-4xl text-metras-green" />
        <p class="text-metras-green">Loading...</p>
      </template>
      <template v-else>
        <img class="max-w-32 object-contain pb-10" :src="'metras_logo.svg'" alt="metras-logo">
        <span>Sie konnten nicht angemeldet werden oder das Portal konnte nicht erreicht werden.</span>
        <ActionButton icon="feather:refresh-cw" label="Noch einmal versuchen" class="bg-metras-green" @click="emit('retry')" />
      </template>
    </div>
  </div>
</template>

<style scoped></style>
